<div class="body audit-body">
    
    <div class="section" *ngIf="(incomingMails$|async)?.length > 0">

        <div class="headline">
            
            <mat-icon class="icon">arrow_right</mat-icon>
            <span class="text">Eingehende E-Mails</span>
            <span class="counter">{{(incomingMails$|async)?.length}}</span>

        </div>

        <div class="section">

            <div class="entry" *ngFor="let mail of (incomingMails$|async)">

                <div class="subject">{{mail.subject}}</div>
                <div class="receiver">Von {{mail.transmitter.name}} ({{mail.transmitter.address}})</div>
                <div class="mail-body" appExpandableDomElement>

                    <quill-view [content]="mail.htmlBody? mail.htmlBody: mail.body" [format]="mail.htmlBody? 'html': 'text'"></quill-view>

                </div>

            </div>

        </div>

    </div>

    <div class="section" *ngIf="(outgoingMails$|async)?.length > 0">

        <div class="headline">
            
            <mat-icon class="icon">arrow_left</mat-icon>
            <span class="text">Gesendete E-Mails</span>
            <span class="counter">{{(outgoingMails$|async)?.length}}</span>

        </div>

        <div class="section">

            <div class="entry" *ngFor="let mail of (outgoingMails$|async)">

                <div class="subject">{{mail.subject}}</div>
                <div class="receiver">An {{mail.receiver.name}} ({{mail.receiver.address}})</div>
                <div class="mail-body" appExpandableDomElement>

                    <quill-view [content]="mail.htmlBody? mail.htmlBody: mail.body" [format]="mail.htmlBody? 'html': 'text'"></quill-view>

                </div>

            </div>

        </div>

    </div>

</div>